const getImageByName = (data, search) => {
  const foundImages = data.filter(image => image.node.name === search)

  return foundImages
}

export default getImageByName
